//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import historyBackJS from './common/historyBack';
export default {
    components: {},
    name: 'main',
    // mixins: [historyBackJS],
    data() {
        return {
            menus: [
                {
                    name: '商城首页',
                    link: '/goods',
                    icon: 'icon-home',
                    badge: 0
                },
                {
                    name: '购物车',
                    link: '/buycar',
                    icon: 'icon-buycar',
                    badge: 0
                },
                {
                    name: '客服',
                    link: '/customer?backPath=' + this.$route.path,
                    icon: 'icon-message',
                    badge: 0
                },
                {
                    name: '个人中心',
                    link: '/mine',
                    icon: 'icon-mine',
                    badge: 0
                }
            ]
        };
    },
    computed: {
        token() {
            return this.$store.state.token;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        carBadge() {
            return this.$store.state.carBadge;
        },
        // 未读消息数
        csrBadge() {
            return this.$store.state.unreadMessageNum;
        }
    },
    watch: {
        carBadge(newVal) {
            this.menus[1].badge = newVal;
        },
        csrBadge(newVal) {
            this.menus[2].badge = newVal;
        },
        userInfo: {
            handler(userInfo) {
                if (userInfo && userInfo.shopperId) {
                    this.$store.state.APPPAGE.getOrderCartNum();
                } else {
                    this.carBadge = this.csrBadge = 0;
                }
            },
            deep: true
        }
    },
    methods: {
        goBack(replace) {
            if (replace) {
                this.$router.replace(this.$route.path);
            }
        }
    },
    mounted() {
        this.$store.state.MAINPAGE = this;
        this.menus[1].badge = this.$store.state.carBadge;
        this.menus[2].badge = this.$store.state.unreadMessageNum;
    }
};



// WEBPACK FOOTER //
// ./src/components/main.vue